import { render, staticRenderFns } from "./BienDetailsPhotos.vue?vue&type=template&id=a6b4f014&scoped=true"
import script from "./BienDetailsPhotos.vue?vue&type=script&lang=js"
export * from "./BienDetailsPhotos.vue?vue&type=script&lang=js"
import style0 from "./BienDetailsPhotos.vue?vue&type=style&index=0&id=a6b4f014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b4f014",
  null
  
)

export default component.exports